// Configuración pública de la app. Los valores se pueden sobrescribir con variables de entorno
// (REACT_APP_*) en .env.production sin tocar el código.
// OJO: nada de esto es secreto; la clave privada de Openpay vive solo en Cloud Functions.
const env = process.env;

export const OPENPAY = {
  merchantId: env.REACT_APP_OPENPAY_MERCHANT_ID || "mtsudiqb6zmjzyshbfgr",
  publicKey: env.REACT_APP_OPENPAY_PUBLIC_KEY || "pk_a2ccc6bacf934518b7125698b3f95a76",
  sandbox: env.REACT_APP_OPENPAY_SANDBOX === "true",
};

// Restringe esta clave por dominio y por app (Android/iOS) en Google Cloud Console
export const GOOGLE_MAPS_API_KEY = env.REACT_APP_GOOGLE_MAPS_API_KEY || "AIzaSyDQfjiw3oAMK7gtBChu4qF9Qq9OdB4XXb4";

// Interruptor de moderación (reportes, bloqueo de usuarios y filtro de contactos en el chat).
// Ponlo en true (o REACT_APP_MODERACION_ACTIVA=true) para habilitarla; requiere las Cloud Functions desplegadas.
export const MODERACION_ACTIVA = env.REACT_APP_MODERACION_ACTIVA === "true";
